import React from 'react';
import times from 'lodash/times';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { Icon } from '../../../CommonComponents/OPL/Icon/Icon';
import { Text } from '../../../CommonComponents/OPL/Text/Text';
import { VisualPickerButton } from '../../../CommonComponents/OPL/VisualPickerButton/VisualPickerButton';
import getImagePath from '../../../CommonUtils/getImagePath';
import {
  IntegrationDTO,
  RISKALYZE,
  useIntegrationsSettingsQuery,
} from './api/useIntegrationsSettingsQuery';
import { INTEGRATION_MODAL_COMPONENTS_MAP, STATUS_MAP } from './Integrations.meta';
import { ErrorState } from '../../../CommonComponents/OPL/AsyncStates/ErrorState/ErrorState';
import { Shimmer } from '../../../CommonComponents/OPL/Shimmer/Shimmer';
import { Header } from './components/Header/Header';

export const Integrations = () => {
  const { isLoading, data, error, refetch } = useIntegrationsSettingsQuery();
  const [selectedIntegration, setSelectedIntegration] = React.useState<IntegrationDTO | null>(null);

  if (isLoading) {
    return (
      <Box display="flex" flexDirection="column" css={{ gap: '16px' }} mt="32">
        {times(4).map(key => (
          <Box key={key}>
            <Shimmer width="100%" height={78} />
          </Box>
        ))}
      </Box>
    );
  }

  if (error) {
    return <ErrorState onAction={() => refetch()} minHeight="400px" />;
  }

  if (!data) {
    return null;
  }

  const IntegrationModal = selectedIntegration
    ? INTEGRATION_MODAL_COMPONENTS_MAP[selectedIntegration?.Name]
    : null;

  const { Integrations: integrationList } = data;

  return (
    <>
      <Header />

      <Box display="flex" flexDirection="column" css={{ gap: '16px' }} mt="32">
        {integrationList.map(integration => (
          <VisualPickerButton
            key={integration.Name}
            onClick={() => {
              setSelectedIntegration(integration);
            }}
          >
            <Box display="flex" alignItems="center" css={{ gap: '8px' }} width="100%">
              <Box
                as="img"
                width="auto"
                maxWidth={34}
                maxHeight={34}
                src={getImagePath(`integrations_logos/${integration.Name}.png`)}
                alt="Firm logo"
              />

              <Box
                display="flex"
                flexDirection="column"
                justifyContent="space-between"
                flexGrow={1}
              >
                <Text variant="cardTitle">{integration.Label}</Text>

                {integration.LastUpdated && (
                  <Text fontSize="small" color="neutral.500" variant="tabular">
                    Last Updated: {integration.LastUpdated}
                  </Text>
                )}
              </Box>

              <Box display="flex" alignItems="center" justifyContent="center" css={{ gap: '16px' }}>
                {STATUS_MAP[integration.Status] && integration.Name !== RISKALYZE && (
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    css={{ gap: '8px' }}
                  >
                    <Text>{STATUS_MAP[integration.Status].label}</Text>
                    <Icon
                      className={`fas ${STATUS_MAP[integration.Status].icon}`}
                      color={STATUS_MAP[integration.Status].color}
                    />
                  </Box>
                )}

                <Icon className="fas fa-chevron-right" />
              </Box>
            </Box>
          </VisualPickerButton>
        ))}

        {selectedIntegration && (
          <IntegrationModal
            integration={selectedIntegration}
            onClose={() => setSelectedIntegration(null)}
          />
        )}
      </Box>
    </>
  );
};
